<template>
  <div class="slider-container">
    <div class="slider" :style="{ transform: `translateX(${-currentSlide * 100}%)` }">
      <div class="slide" v-for="(slide, index) in slides" :key="index">
        <img :src="slide.image" :alt="slide.alt" @click="handleSlideClick(slide.link)">
      </div>
    </div>
    <div class="slider-controls">
      <div class="prev" @click="prevSlide">&#10094;</div>
      <div class="next" @click="nextSlide">&#10095;</div>
      <div class="dots">
        <span 
          v-for="(slide, index) in slides" 
          :key="index" 
          :class="{ active: currentSlide === index }"
          @click="goToSlide(index)">
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SliderView',
  data() {
    return {
      currentSlide: 0,
      slides: [
        {
          image: require('@/assets/img/banner.png'),
          alt: '首页',
          link: '/'
        },
        {
          image: require('@/assets/img/banner2.gif'),
          alt: '素材资源',
          link: '/page/resourse'
        }
      ],
      autoplayInterval: null
    }
  },
  mounted() {
    this.startAutoplay();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    this.stopAutoplay();
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
      this.resetAutoplay();
    },
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.slides.length;
      this.resetAutoplay();
    },
    goToSlide(index) {
      this.currentSlide = index;
      this.resetAutoplay();
    },
    handleSlideClick(link) {
      this.$router.push(link);
    },
    startAutoplay() {
      this.autoplayInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
    stopAutoplay() {
      clearInterval(this.autoplayInterval);
    },
    resetAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    },
    handleResize() {
      // 可以在这里添加响应式逻辑
    }
  }
}
</script>

<style scoped>
.slider-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
  margin-bottom: 20px;
  line-height: 0;
  display: block;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.slider {
  display: flex;
  transition: transform 0.5s ease;
  height: 400px;
  width: 100%;
}

.slide {
  min-width: 100%;
  position: relative;
  line-height: 0;
}

.slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
  display: block;
}

.slider-controls {
  position: relative;
}

.prev, .next {
  position: absolute;
  top: -200px;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.5);
  color: var(--text-color);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  font-size: 18px;
  z-index: 10;
  transition: background-color 0.3s ease;
}

.prev:hover, .next:hover {
  background-color: rgba(255, 255, 255, 0.8);
}

.prev {
  left: 20px;
}

.next {
  right: 20px;
}

.dots {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
}

.dots span {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.dots span.active {
  background-color: var(--primary-color);
}

@media screen and (max-width: 768px) {
  .slider {
    height: 250px;
  }
  
  .prev, .next {
    top: -125px;
    width: 30px;
    height: 30px;
    font-size: 14px;
  }
  
  .prev {
    left: 10px;
  }
  
  .next {
    right: 10px;
  }
}

@media screen and (max-width: 480px) {
  .slider {
    height: 180px;
  }
  
  .prev, .next {
    top: -90px;
    width: 25px;
    height: 25px;
    font-size: 12px;
  }
}
</style>